import React, { useCallback } from "react";
import { Redirect } from "react-router-dom";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { SettingsTemplate } from "../../../template/settings/default-template";
import { SettingR } from "../route";
import { FeatureTitles } from "../../../../application/domain/faeture-titles";
import { useAuthContextV2 } from "../../../../auth-state";
import {
  DateRangeInput,
  FilterContainer,
  PrimaryButton,
  Spinner,
} from "@graffer-inc/console-design-kit";
import {
  UserAuditLogContextProps,
  UserAuditService,
} from "../../../../application/service/smart-apply/audit/user-audit-service";
import dayjs from "dayjs";
import { userAuditLogOldestAvailableDate } from "../../../../application/domain/audit/user-audit-log";

const handleStartFrom = (date: Date | null) => {
  if (date) {
    return dayjs(date).toDate();
  }
  return userAuditLogOldestAvailableDate();
};

const handleEndTo = (date: Date | null) => {
  if (date) {
    return dayjs(date).toDate();
  }
  return dayjs().toDate();
};

const AuthAuditLogPage: React.FC<UserAuditLogContextProps> = ({
  isLoading,
  dateRange,
  setFilterCondition,
  downloadCSV,
}) => {
  const { auth } = useAuthContextV2();

  const handleOnSetValue = useCallback(
    ({
      startDate,
      endDate,
    }: {
      startDate: Date | null;
      endDate: Date | null;
    }) => {
      setFilterCondition({
        dateRange: {
          from: handleStartFrom(startDate),
          to: handleEndTo(endDate),
        },
      });
    },
    [setFilterCondition],
  );

  if (!auth.hasPermissions("audit_logs.read")) {
    return <Redirect to={SettingR.MyAccount.link({})} />;
  }

  return (
    <SettingsTemplate
      breadcrumbs={[
        { to: SettingR.UserAudit.link({}), title: FeatureTitles.UserAuditLog },
      ]}
    >
      <h1 className="title">
        <i className="fa fa-user" /> {FeatureTitles.UserAuditLog}
      </h1>
      <FilterContainer
        buttons={[
          <PrimaryButton text={"CSVダウンロード"} onClick={downloadCSV} />,
        ]}
      >
        {/* TODO(hirata): InlineDateRangeInputがGCDKでリリースされたら置き換える */}
        <div className="columns mt-2 is-paddingless is-vcentered">
          <div
            className="column is-marginless is-paddingless is-narrow has-text-right"
            style={{
              width: "120px",
            }}
          >
            <strong>日付範囲</strong>
          </div>
          <div className="column">
            <DateRangeInput
              startDate={dateRange.from}
              endDate={dateRange.to}
              setValue={handleOnSetValue}
              minDate={userAuditLogOldestAvailableDate()}
              maxDate={dayjs().toDate()}
            />
          </div>
        </div>
      </FilterContainer>
      <Spinner loading={isLoading} />
    </SettingsTemplate>
  );
};

export const UserAuditLogContainer = connectPageService(
  AuthAuditLogPage,
  () => new UserAuditService(),
);
